import {
  text,
  area,
  title,
  minMax,
  autocomplete,
  multiselect,
} from '../filter-builder';

const filterSet = (filters) => ({
  exclude = [],
  append = [],
  overrides = {},
} = {}) => [
    ...filters
      .filter(({ key }) => !exclude.includes(key))
      .map((filter) => ({
        ...filter,
        ...(overrides[filter.key] || filter),
      })),
    ...append,
  ];

export const socioEconomicDemographicsFilters = filterSet([
  title('Socioeconomics & Demographics'),

  minMax({
    label: 'Population',
    key: 'population',
  }),

  minMax({
    label: 'Social Vulnerability',
    key: 'social_vulnerability',
    unit: 'DECIMAL',
  }),
  minMax({
    label: 'Median Household Income',
    key: 'med_hh_inc',
  }),

  minMax({
    label: 'Broadband Internet Access',
    key: 'broadband',
    unit: 'PERCENT',
  }),
  minMax({
    label: 'Households with Computer Access',
    key: 'hh_w_comp',
    unit: 'PERCENT',
  }),
  minMax({
    label: 'Poverty Rate',
    key: 'pov_pct',
    unit: 'PERCENT',
  }),
  minMax({
    label: "Bachelor's Degree Holder Rate",
    key: 'ed_ba_plus',
    unit: 'PERCENT',
  }),
  minMax({
    label: 'Households with Children Under 18',
    key: 'hh_w_kids',
    unit: 'PERCENT',
  }),
  minMax({
    label: 'Hispanic or Latino (of any race)',
    key: 'hispanic',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population White',
    key: 'rc_white',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Black or African American',
    key: 'rc_afam',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population American Indian or Alaska Native',
    key: 'rc_natv',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Asian',
    key: 'rc_asian',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Native Hawaiian or Other Pacific Islander',
    key: 'rc_islnd',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Other Race',
    key: 'rc_other',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Two or More Races',
    key: 'rc_2p',
    unit: 'PERCENT',
  }),
]);


export const socioEconomicDemographicsFiltersParcels = filterSet([
  title('Socioeconomics & Demographics'),

  minMax({
    label: 'Median Household Income',
    key: 'med_hh_inc',
  }),

  minMax({
    label: 'Poverty Rate',
    key: 'pov_pct',
    unit: 'PERCENT',
  }),
  minMax({
    label: "Bachelor's Degree Holder Rate",
    key: 'ed_ba_plus',
    unit: 'PERCENT',
  }),
  minMax({
    label: 'Households with Children Under 18',
    key: 'hh_w_kids',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population White',
    key: 'rc_white',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Black or African American',
    key: 'rc_afam',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population American Indian or Alaska Native',
    key: 'rc_natv',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Asian',
    key: 'rc_asian',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Native Hawaiian or Other Pacific Islander',
    key: 'rc_islnd',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Other Race',
    key: 'rc_other',
    unit: 'PERCENT',
  }),
  minMax({
    label: '% of Population Two or More Races',
    key: 'rc_2p',
    unit: 'PERCENT',
  }),
]);

export const filters = [
  {
    type: 'PARENT',
    label: 'Completed Investments',
    source: 'census_history',
    dataKey: 'fips',
    filters: [
      area(),
      autocomplete({
        label: 'County',
        key: 'name_county',
        provider: 'census_history',
      }),
      text({
        label: 'Municipality',
        key: 'name_cousub_lookup',
        provider: 'census_history',
        prepend: '|',
        postpend: '|',
      }),

      title('Housing & Real Estate'),

      minMax({
        label: 'Median Home Value',
        key: 'med_hom_val',
        unit: 'DOLLARS',
      }),
      multiselect({
        label: 'Housing Market Strength',
        key: 'submarket',
      }),
      minMax({
        label: 'Housing Affordability',
        key: 'housing_affordability',
        unit: 'DECIMAL',
      }),
      minMax({
        label: 'Housing Affordability - Renters',
        key: 'housing_affordability_renters',
        unit: 'DECIMAL',
      }),
      minMax({
        label: 'Housing Affordability - Owners',
        key: 'housing_affordability_owners',
        unit: 'DECIMAL',
      }),
      minMax({
        label: 'Median Rent',
        key: 'med_rent',
        unit: 'DOLLARS',
      }),
      minMax({
        label: 'Vacancy Rate',
        key: 'hu_unocc',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Owner Occupancy Rate',
        key: 'hu_own_occ',
        unit: 'PERCENT',
      }),

      title('Education'),

      minMax({
        label: 'High school graduate (includes equivalency)',
        key: 'ed_hs_plus',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Associate\'s degree',
        key: 'ed_assoc_plus',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Bachelor\'s degree',
        key: 'ed_ba_plus',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Graduate or professional degree',
        key: 'ed_doc_plus',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Nursery school, preschool (%)',
        key: 'enroll_preschool_pct',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Nursery school, preschool (count)',
        key: 'enroll_preschool',
      }),

      title('Economic'),

      minMax({
        label: 'Employed',
        key: 'emp_pct',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Unemployed',
        key: 'unemp_pct',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Agriculture, forestry, fishing and hunting, and mining',
        key: 'ind_agff',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Construction',
        key: 'ind_construction',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Manufacturing',
        key: 'ind_manufacture',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Wholesale trade',
        key: 'ind_wholesale',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Retail trade',
        key: 'ind_retail',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Transportation and warehousing, and utilities',
        key: 'ind_trans',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Information',
        key: 'ind_info',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Finance and insurance, and real estate and rental and leasing',
        key: 'ind_finance',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Professional, scientific, and management, and administrative and ',
        key: 'ind_pro_science',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Educational services, and health care and social assistance',
        key: 'ind_ed',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Arts, entertainment, and recreation, and accommodation and food services',
        key: 'ind_art',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Other services, except public administration',
        key: 'ind_other',
        unit: 'PERCENT',
      }),
      minMax({
        label: 'Public administration',
        key: 'ind_public',
        unit: 'PERCENT',
      }),

      ...socioEconomicDemographicsFilters(),

      title('Neighborhood Revitalization'),

      minMax({
        label: 'Predicted Rehabilitation Impact',
        key: 'rehab_impact_pred',
        unit: 'DOLLARS',
      }),
      minMax({
        label: 'Predicted Demolition Impact',
        key: 'demo_impact_pred',
        unit: 'DOLLARS',
      }),
      minMax({
        label: 'Predicted # of Homes Impacted',
        key: 'homes_impacted',
      }),
    ],
  },
];
